if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e))
})()


/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/


function updateMenuTabIndex() {
	const menu = document.querySelector('.mega-menu');
	const isMenuVisible = menu && menu.classList.contains('show');
	const elements = document.querySelectorAll('.privary-navigation__item a');

	elements.forEach(element => {
			element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}


document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();


	document.addEventListener('focusin', updateMenuTabIndex);
	const menu = document.querySelector('.mega-menu');
	if (menu) {
			menu.addEventListener('transitionend', updateMenuTabIndex);
	}
});
